<div class="upcoming-bills-widget" [class.small]="size === 'small'" (click)="openModal()">
  <!-- Header with Title and Edit Pencil -->
  <div class="bills-header">
    <div class="header-content">
      <div class="bills-title">{{ title }}</div>
      <ng-container *ngIf="isEditMode">
        <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
          cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
          <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
        </div>
        <!-- Size Dropdown -->
        <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
          [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
          [toggleSizeDropdown]="toggleSizeDropdown">
        </app-widget-edit>
      </ng-container>
      <ng-container *ngIf="isAddMode">
        <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
          (click)="addWidget.emit(); $event.stopPropagation()" />
      </ng-container>
    </div>
  </div>

  <!-- Main Content -->
  <div class="bills-main">
    <ng-container *ngIf="size !== 'small'; else smallView">
      <!-- Netflix Item -->
      <div class="bill-item">
        <div class="logo-container">
          <img src="assets/icons/Netflix-Logo.wine 1.svg" class="logo-img netflix-logo-img no-dark-filter"
            alt="Netflix" />
        </div>
        <div class="bill-info">
          <div class="bill-name-group">
            <div class="bill-name">Netflix</div>
          </div>
          <div class="bill-amount-group">
            <div class="bill-amount">$15</div>
            <div class="bill-frequency">/ monthly</div>
          </div>
        </div>
      </div>

      <!-- Internet Item -->
      <div class="bill-item">
        <div class="logo-container white-bg">
          <img src="assets/icons/image 7.png" class="logo-img airtel-logo-img no-dark-filter" alt="Airtel" />
        </div>
        <div class="bill-info">
          <div class="bill-name-group">
            <div class="bill-name">Internet</div>
          </div>
          <div class="bill-amount-group">
            <div class="bill-amount">₹12,500</div>
            <div class="bill-frequency">/ monthly</div>
          </div>
        </div>
      </div>

      <!-- Gym Item -->
      <div class="bill-item">
        <div class="logo-container gradient-bg">
          <img src="assets/icons/img-star.svg" class="star-icon no-dark-filter" alt="Gym" />
        </div>
        <div class="bill-info">
          <div class="bill-name-group">
            <div class="bill-name">Gym “Olympus”</div>
          </div>
          <div class="bill-amount-group">
            <div class="bill-amount">$15</div>
            <div class="bill-frequency">/ monthly</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Small View (Single Prominent Item) -->
    <ng-template #smallView>
      <div class="bill-item prominent">
        <div class="top-group">
          <div class="logo-container gradient-bg">
            <img src="assets/icons/img-star.svg" class="star-icon no-dark-filter" alt="Gym" />
          </div>
          <div class="bill-name">Gym “Olympus”</div>
        </div>
        <div class="bottom-group">
          <div class="bill-amount">₹12,500</div>
          <div class="bill-frequency">/ monthly</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>